// extracted by mini-css-extract-plugin
export default {"imgContainer":"cancel_imgContainer__vy5Po","imagen":"cancel_imagen__mpj8Q"};